/**
 * itemData.operationType for media-handle uploadImages (must match MyHub_MediaHandling validation).
 */

export const OPERATION_TYPE = {
  /** Manifest read / hub presign GET — storeId not required */
  GET_HUB_PRESIGNED_URL: "GetHubPresignedUrl",
  GET_BIZ_PRESIGNED_URL: "GetBizPresignedUrl",
  /** Items shared gallery (manifest GET / presign read) — must match media Lambda */
  GET_ITEMS_GALLERY_PRESIGNED_URL: "GetItemsPresignedUrl",
  /** Gallery image PUT — hub segment */
  PUT_HUB_PRESIGNED_URL: "PutHubPresignedUrl",
  PUT_BIZ_PRESIGNED_URL: "PutBizPresignedUrl",
  PUT_ITEMS_GALLERY_PRESIGNED_URL: "PutItemsPresignedUrl",
  /** Per-item image upload (legacy stores/.../items/itemId path) */
  PUT_ITEM_IMAGE_PRESIGNED_URL: "PutItemImagePresignedUrl",
};

/** @param {'hub'|'biz'|'items'} gallerySegment */
export function operationTypeForManifestRead(gallerySegment) {
  if (gallerySegment === "hub") return OPERATION_TYPE.GET_HUB_PRESIGNED_URL;
  if (gallerySegment === "biz") return OPERATION_TYPE.GET_BIZ_PRESIGNED_URL;
  return OPERATION_TYPE.GET_ITEMS_GALLERY_PRESIGNED_URL;
}

/** @param {'hub'|'biz'|'items'} segment */
export function operationTypeForGalleryUpload(segment) {
  if (segment === "hub") return OPERATION_TYPE.PUT_HUB_PRESIGNED_URL;
  if (segment === "biz") return OPERATION_TYPE.PUT_BIZ_PRESIGNED_URL;
  return OPERATION_TYPE.PUT_ITEMS_GALLERY_PRESIGNED_URL;
}
